export default __webpack_public_path__ + "static/media/N_Roch_school.236d453a.png";